import Swiper from "swiper";
import "swiper/css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
	var swiper = Swiper;
	var init = false;

	function serviceCards() {
		if (window.innerWidth <= 1320) {
			if (!init) {
				init = true;
				swiper = new Swiper("#serviceCards", {
					direction: "horizontal",
					slidesPerView: 1.25,
					spaceBetween: 10,

					breakpoints: {
						650: {
							slidesPerView: 2.2,
							spaceBetween: 20,
						},
						1024: {
							slidesPerView: 2.8,
							spaceBetween: 20,
						},
					},
				});
			}
		} else if (init) {
			swiper.destroy();
			init = false;
		}
	}
	serviceCards();
	window.addEventListener("resize", serviceCards);

	/**
	 * SERVICE CARDS ANIMATION
	 */
	if (window.innerWidth >= 1024) {
		var serviceCardsAnim = gsap.timeline();
		serviceCardsAnim.fromTo(
			".card",
			{ y: 30, autoAlpha: 0 },
			{ y: 0, autoAlpha: 1, duration: 1, stagger: 0.5, ease: "ease" }
		);

		ScrollTrigger.create({
			start: "top 75%",
			end: "bottom 50%",
			trigger: ".services__work",
			animation: serviceCardsAnim,
			toggleActions: "play complete none none",
			once: false,
			markers: false,
		});
	}
});
